import { useOnboarding } from '../../contexts/OnboardingContext'
import { ChoosePathStep } from './steps/ChoosePathStep'
import { CompanyDetailsStep } from './steps/CompanyDetailsStep'
import { LocationSetupStep } from './steps/LocationSetupStep'
import { ConstraintsStep } from './steps/ConstraintsStep'
import { InvitationsStep } from './steps/InvitationsStep'
import { ReviewStep } from './steps/ReviewStep'

export default function OnboardingWizard() {
  const { currentStep } = useOnboarding()
  
  const steps = [
    { component: ChoosePathStep, title: 'Get Started' },
    { component: CompanyDetailsStep, title: 'Company Details' },
    { component: LocationSetupStep, title: 'First Location' },
    { component: ConstraintsStep, title: 'Clock-In Settings' },
    { component: ReviewStep, title: 'Review & Confirm' },
    { component: InvitationsStep, title: 'Invite Team' }
  ]
  
  const CurrentStepComponent = steps[currentStep]?.component || ChoosePathStep
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Progress bar */}
      <div className="bg-white shadow-sm">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-lg font-semibold text-gray-900">
              {steps[currentStep]?.title}
            </h2>
            <span className="text-sm text-gray-500">
              Step {currentStep + 1} of {steps.length}
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
            />
          </div>
        </div>
      </div>
      
      {/* Step content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-2xl">
          <CurrentStepComponent />
        </div>
      </div>
    </div>
  )
}